// import React, { useState } from 'react';
// import { NavLink } from "react-router-dom";
// import $ from "jquery";
// import { toast } from "react-toastify";

// function DepositCard({ data }) {
//   const [quantity, setQuantity] = useState('10');

//   async function handleCart() {
//     try {
//       if (!localStorage.getItem("UserId")) {
//         toast.warn("You need to login to add items to your cart.");
//         return;
//       }

//       const card = $('.card-footer');
//       card.find("button").attr("disabled", true);
//       const toaster = toast.loading("Processing...");

//       let cart = localStorage.getItem('cart');
//       cart = cart ? JSON.parse(cart) : [];

//       const exists = cart.some(item => item.name.toLowerCase() === data.name.toLowerCase());

//      if (!exists) {
//   const depositItem = {
//     id: data.id,
//     name: data.name,
//     amount: parseFloat(quantity),
//   };

//   cart.push(depositItem);

//         localStorage.setItem('cart', JSON.stringify(cart));
//         $('#cart-badge').text(cart.length);

//         toast.update(toaster, {
//           type: "success",
//           render: "Item added to cart successfully.",
//           isLoading: false,
//           autoClose: 2000,
//           closeButton: true,
//         });
//       } else {
//         toast.update(toaster, {
//           type: "info",
//           render: "This item is already in your cart.",
//           isLoading: false,
//           autoClose: 2000,
//           closeButton: true,
//         });
//       }

//       card.find("button").attr("disabled", false);
//     } catch (e) {
//       console.error(e);
//     }
//   }

//   return (
//     <div className="deposit-card-container">
//       <div className="deposit-card">
//         <div className="card-header">
//           <img src={data.image} alt={data.name} />
//         </div>

//         <div className="card-body">
//           <div className="card-info-row">
//             <div className="card-title">{data.name}</div>
//             <div className="card-quantity custom-number">
//               <span className="currency-symbol">$</span>
//               <input
//                 type="number"
//                 value={quantity}
//                 min={10}
//                 readOnly
//               />
//               <div className="spinner-buttons">
//                 <button onClick={() => setQuantity(prev => `${Math.max(+prev + 1, 10)}`)}>▲</button>
//                 <button onClick={() => setQuantity(prev => `${Math.max(+prev - 1, 10)}`)}>▼</button>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card-footer">
//           <NavLink to={data.path} className="btn1 demo">REDEEM</NavLink>
//           <button className="btn1 cart" onClick={handleCart}>ADD TO CART</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default DepositCard;
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import { toast } from 'react-toastify';

function DepositCard({ data }) {
  const [quantity, setQuantity] = useState('10');
  const navigate = useNavigate(); // ✅ Initialize navigate

  // ✅ Handle Redeem Logic
  const handleRedeem = () => {
    const isLoggedIn = !!localStorage.getItem('UserId');
    if (isLoggedIn) {
      navigate('/user/withdrawals');
    } else {
      navigate('/login');
    }
  };

  async function handleCart() {
    try {
      if (!localStorage.getItem('UserId')) {
        toast.warn('You need to login to add items to your cart.');
        return;
      }

      const card = $('.card-footer');
      card.find('button').attr('disabled', true);
      const toaster = toast.loading('Processing...');

      let cart = localStorage.getItem('cart');
      cart = cart ? JSON.parse(cart) : [];

      const exists = cart.some(
        (item) => item.name.toLowerCase() === data.name.toLowerCase()
      );

      if (!exists) {
        const depositItem = {
          id: data.id,
          name: data.name,
          amount: parseFloat(quantity),
        };

        cart.push(depositItem);
        localStorage.setItem('cart', JSON.stringify(cart));
        $('#cart-badge').text(cart.length);

        toast.update(toaster, {
          type: 'success',
          render: 'Item added to cart successfully.',
          isLoading: false,
          autoClose: 2000,
          closeButton: true,
        });
      } else {
        toast.update(toaster, {
          type: 'info',
          render: 'This item is already in your cart.',
          isLoading: false,
          autoClose: 2000,
          closeButton: true,
        });
      }

      card.find('button').attr('disabled', false);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div className="deposit-card-container">
      <div className="deposit-card">
        <div className="card-header">
          <img src={data.image} alt={data.name} />
        </div>

        <div className="card-body">
          <div className="card-info-row">
            <div className="card-title">{data.name}</div>
            <div className="card-quantity custom-number">
              <span className="currency-symbol">$</span>
              <input type="number" value={quantity} min={10} readOnly />
              <div className="spinner-buttons">
                <button
                  onClick={() =>
                    setQuantity((prev) => `${Math.max(+prev + 1, 10)}`)
                  }
                >
                  ▲
                </button>
                <button
                  onClick={() =>
                    setQuantity((prev) => `${Math.max(+prev - 1, 10)}`)
                  }
                >
                  ▼
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="card-footer">
          <button className="btn1 demo" onClick={handleRedeem}>
            REDEEM
          </button>
          <button className="btn1 cart" onClick={handleCart}>
            ADD TO CART
          </button>
        </div>
      </div>
    </div>
  );
}

export default DepositCard;

